"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getAnswer = getAnswer;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _highcharts = _interopRequireDefault(require("highcharts"));

var _reactJsxHighcharts = require("react-jsx-highcharts");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _FeedbackProvider = require("./FeedbackProvider");

function getAnswer(feedback, answer) {
  var key = "".concat(answer.uuid);

  if (feedback.hasOwnProperty(key)) {
    return feedback["".concat(key, "_abs")];
  }

  return 0;
}

function BarChart(_ref) {
  var categories = _ref.categories,
      answers = _ref.answers,
      title = _ref.title,
      id = _ref.id;
  var feedbacks = (0, _FeedbackProvider.useFeedbackContext)();

  if (feedbacks && feedbacks[id]) {
    var votes = answers.map(function (answer) {
      return getAnswer(feedbacks[id], answer);
    });
    return /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.HighchartsChart, null, /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.Chart, {
      height: 250
    }), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.XAxis, {
      categories: categories,
      allowDecimals: false
    }), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.YAxis, {
      allowDecimals: false
    }, /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.YAxis.Title, null, title), /*#__PURE__*/_react["default"].createElement(_reactJsxHighcharts.ColumnSeries, {
      dataLabels: {
        enabled: true
      },
      data: votes
    })));
  }

  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body1"
  }, "Keine Auswertung verf\xFCgbar");
}

BarChart.propTypes = {
  categories: _propTypes["default"].array,
  answers: _propTypes["default"].array,
  title: _propTypes["default"].string,
  id: _propTypes["default"].string
};

var _default = (0, _reactJsxHighcharts.withHighcharts)(BarChart, _highcharts["default"]);

exports["default"] = _default;